import { PromoTile } from './PromoTile';
import { useSiteImages } from '../../hooks/useSiteImages';

interface ShopBySizeProps {
  onSelectSize: (variationValues: string[]) => void;
}

interface SizeBucket {
  key: string;
  label: string;
  imageKey: string;
  variationValues: string[];
}

const SIZE_BUCKETS: SizeBucket[] = [
  { key: '1-4', label: '1 a 4 anos', imageKey: 'size-1-4', variationValues: ['1', '2', '4'] },
  { key: '6-8', label: '6 a 8 anos', imageKey: 'size-6-8', variationValues: ['6', '8'] },
  { key: '10-12', label: '10 a 12 anos', imageKey: 'size-10-12', variationValues: ['10', '12'] },
  { key: '14', label: '14 anos', imageKey: 'size-14', variationValues: ['14'] },
];

export function ShopBySize({ onSelectSize }: ShopBySizeProps) {
  const { siteImages } = useSiteImages();

  return (
    <div className="max-w-6xl mx-auto px-4 pt-10">
      <p className="text-xs font-bold uppercase tracking-[0.18em] text-chocolate-dark mb-4">
        Compre por tamanho
      </p>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {SIZE_BUCKETS.map((bucket) => (
          <PromoTile
            key={bucket.key}
            label={bucket.label}
            image={siteImages[bucket.imageKey]}
            onClick={() => onSelectSize(bucket.variationValues)}
          />
        ))}
      </div>
    </div>
  );
}
